module.exports = __webpack_public_path__ + "img/logo.4a962101.svg";